<template>
  <svg
    class="radar_section_line"
    :style="{ transform: 'rotate(' + rotateAngle + 'deg)' }"
    height="300"
    width="300"
  >
    <circle cx="150" cy="150" r="147" :stroke="lineColor" stroke-width="1" fill="transparent" />
  </svg>
</template>

<script>
export default {
  name: 'RadarSectionLine',

  props: {
    lineColor: {
      type: String,
      required: true,
    },
    rotateAngle: {
      type: Number,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.radar_section_line circle {
  stroke-dashoffset: 378%;
  stroke-dasharray: 330%;

  @include helper__greater($bp-1024) {
    stroke-width: 0.5;
  }
}
</style>
